import { useUserInfoContext } from "../lib/contexts/UserInfoContext";
import { Navigate, Outlet } from "react-router-dom";

export function AdminRoute() {
  const { userInfo } = useUserInfoContext();

  if (!userInfo?.isAdmin) {
    return <Navigate to="/unauthorized" replace />;
  }

  return <Outlet />;
}
